import React, { Component } from "react"
import { Link, Redirect } from "react-router-dom"
import PropTypes from "prop-types"
import Button from "../../components/Button"
import "./message.scss"

class Message extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirectToReferrer: false,
    }
  }

  callToActionRedirect = () => {
    this.setState({
      redirectToReferrer: true,
    })
  }

  render() {
    let { title, message, type, children, callToAction, isModal } = this.props

    if (this.state.redirectToReferrer) {
      return <Redirect to={`/${callToAction.route}`} />
    }

    return (
      <div className="message-center">
        <div className="message-container">
          <div className="message">
            {type === "success" && <span className="icon-circle-success" />}
            {type === "error" && <span className="icon-circle-error" />}
            <h2>{title}</h2>
            <p>{message}</p>
            {children && <div className="message-action">{children}</div>}

            {callToAction && isModal ? (
              <CallToAction
                {...this.props}
                redirect={this.callToActionRedirect}
              />
            ) : null}
          </div>

          {callToAction && !isModal ? (
            <CallToAction
              {...this.props}
              redirect={this.callToActionRedirect}
            />
          ) : null}
        </div>
      </div>
    )
  }
}

const CallToAction = (props) => {
  let { callToAction, isModal } = props
  return (
    <div className={`call-to-action ${isModal && "isModal"}`}>
      <p>{callToAction.text}</p>
      <Button
        action={
          isModal && props.type === "error"
            ? callToAction.closeModal
            : props.redirect
        }
        classes={["btn-primary", `${!isModal && "btn-outline"}`]}
      >
        {callToAction.buttonText}
      </Button>
    </div>
  )
}

Message.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  type: PropTypes.string,
  isModal: PropTypes.bool,
  callToAction: PropTypes.shape({
    text: PropTypes.string,
    route: PropTypes.string,
    buttonText: PropTypes.string,
  }),
}

export default Message
